import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';

export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    },
    domainID() {
      return +this.$route.params.domainID;
    },
    productGroupID() {
      return +this.$route.params.productGroupID;
    },
    productGroup() {
      return this.$store.getters['productGroup/getLoadedItemByID'](+this.$route.params.productGroupID);
    },
    domainName() {
      const domain = this.$store.getters['domain/getLoadedItemByID'](this.$route.params.domainID);
      return domain && domain.name;
    },
    productGroupDescription() {
      return this.$route.params.description;
    }
  },
  mixins: [baseCrudMixin],
  async created() {
    await this.$store.dispatch('productGroup/getItems');
    await this.$store.dispatch('parcelType/getItems');
  },
  data: () => ({
    entity: 'LinkDomainProductGroup',
    returnTo: 'LinkDomainProductGroups'
  }),
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData,
    isProductGroupType(productGroupTypeOptions) {
      const productGroup = this.productGroup;
      return productGroup && productGroupTypeOptions.some(e => e === productGroup.productGroupTypeOption);
    }
  }
};
